import { AxiosRequestConfig } from "axios";

export const postSignInMicrosoftConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user/oauth",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
